var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCauses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6676 2.85051C14.4528 2.29133 14.1439 1.78999 13.7636 1.36716C13.3813 0.944333 12.9257 0.603206 12.4226 0.367123C11.9171 0.13157 11.3632 0 10.779 0C10.1978 0 9.6443 0.16181 9.13832 0.447762C8.63426 0.731593 8.17912 1.13904 7.79735 1.62553C7.69232 1.75975 7.59256 1.89981 7.49904 2.04517C7.40552 1.89981 7.30624 1.75922 7.20169 1.62553C6.81945 1.13957 6.36382 0.731593 5.86072 0.447762C5.3557 0.16181 4.80129 0 4.21761 0C3.63681 0 3.08048 0.13157 2.5769 0.366592C2.07092 0.602675 1.61817 0.944333 1.23545 1.36663C0.85321 1.78999 0.544827 2.2908 0.331404 2.84998C0.118941 3.40756 0 4.02296 0 4.66543C0 5.31108 0.118941 5.92383 0.331404 6.48353C0.544827 7.04005 0.85321 7.54458 1.23545 7.96688C1.61817 8.38706 6.99402 13.7613 7.5 14C8.0031 13.7613 13.3818 8.38706 13.7636 7.96688C14.1439 7.54405 14.4528 7.04005 14.6676 6.48353C14.8801 5.92436 15 5.31108 15 4.66543C15 4.02296 14.8806 3.40756 14.6676 2.85051Z",
    fill: "#05C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCauses);
export default __webpack_public_path__ + "static/media/causes.fd4553f4.svg";
export { ForwardRef as ReactComponent };